import { render } from "./ImageContentPluginForm.vue?vue&type=template&id=7f8d36c8"
import script from "./ImageContentPluginForm.vue?vue&type=script&lang=js"
export * from "./ImageContentPluginForm.vue?vue&type=script&lang=js"

import "./ImageContentPluginForm.vue?vue&type=style&index=0&id=7f8d36c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__